import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import { saveAs } from "file-saver";
import DocumentModelBox from "./DocumentModalBox";
import csvIcon from "../../assets/images/icons/csv.png";
import pdfIcon from "../../assets/images/icons/pdf.png";
import docIcon from "../../assets/images/icons/doc.png";
import docxIcon from "../../assets/images/icons/doc.png";
import xlsIcon from "../../assets/images/icons/xls.png";
import pptIcon from "../../assets/images/icons/ppt.png";
import { Tooltip, useMediaQuery, useTheme } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { s3baseUri } from "../../config/config";

function DocumentPreview({ files, dataapi }) {
  console.log(dataapi, "dataapidataapidataapidataapi");
  console.log(files, "filesfilesfilesfiles");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [previewDoc, setPreviewDoc] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [currentType, setCurrentType] = useState("other_document");

  const getFileExtension = (url) => {
    try {
      return url.split(".").pop().split("?")[0].toLowerCase();
    } catch {
      return "";
    }
  };

  const getFileType = (ext) => {
    const imageTypes = ["jpg", "jpeg", "png", "gif", "webp"];
    if (imageTypes.includes(ext)) return "image";
    if (ext === "pdf") return "pdf";
    if (["mp3", "wav", "ogg"].includes(ext)) return "audio";
    return "other_document";
  };

  const getFileIcon = (ext) => {
    const iconSize = isMobile ? 36 : 65;
    switch (ext) {
      case "pdf":
        return (
          <img
            src={pdfIcon}
            alt="PDF"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "doc":
        return (
          <img
            src={docIcon}
            alt="DOC"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "docx":
        return (
          <img
            src={docxIcon}
            alt="DOCX"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "xls":
      case "xlsx":
        return (
          <img
            src={xlsIcon}
            alt="Excel"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "ppt":
      case "pptx":
        return (
          <img
            src={pptIcon}
            alt="PowerPoint"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "csv":
        return (
          <img
            src={csvIcon}
            alt="CSV"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      default:
        return "";
    }
  };

  const handleDownload = async (value) => {
    let path = "";
    if (value.document_type === "image") {
      path = value.document_images_url.thumbnail_1;
    } else if (value.document_type === "audio") {
      path = value.document_file_url;
    } else {
      path = value.uri;
    }

    const file_path = `${s3baseUri}${path}`;
    fetch(file_path)
      .then(async (res) => {
        if (res.status === 200) {
          let blob = await res.blob();
          const extension = getFileExtension(path);
          const fileName = `${dataapi.title || "document"}.${extension}`;
          saveAs(blob, fileName);
        } else {
          enqueueSnackbar(res.statusText, { variant: "error" });
        }
      })
      .catch((err) => {
        enqueueSnackbar("Download failed", { variant: "error" });
      });
  };

  const handleOpenPreview = (doc) => {
    const ext = getFileExtension(doc.uri);
    setCurrentType(getFileType(ext));
    setPreviewDoc({
      ...doc,
      type: getFileType(ext),
    });
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setPreviewDoc(null);
  };

  const docs = files?.map((file) =>
    typeof file === "string" ? { uri: file } : file
  );

  return (
    <div style={{ overflowX: "hidden" }}>
      {/* Grid Layout for Documents */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(4, 1fr)",
          gap: "15px",
          marginBottom: "30px",
        }}
      >
        {docs?.map((doc, idx) => {
          const fileUrl = doc.uri || "";
          const ext = getFileExtension(fileUrl);

          return (
            <div
              key={idx}
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: isMobile ? "10px" : "15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: isMobile ? "8px" : "25px",

                minHeight: "80px",
                position: "relative",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                overflow: "hidden",
                background: "#fff",
              }}
            >
              {/* Left Side - Only Icon */}
              <div style={{ display: "flex", alignItems: "center" }}>
                {getFileIcon(ext)}
              </div>

              {/* Right Side - Action Icons */}
              <div
                style={{
                  display: "flex",
                  gap: isMobile ? "8px" : "15px",
                  alignItems: "center",
                  marginRight: isMobile ? "" : "12px",
                }}
              >
                <Tooltip title="Preview">
                  <VisibilityIcon
                    onClick={() => handleOpenPreview(doc)}
                    style={{
                      color: "navy",
                      cursor: "pointer",
                      fontSize: isMobile ? "20px" : "24px",
                    }}
                  />
                </Tooltip>
                <Tooltip title="Download">
                  <DownloadIcon
                    onClick={() => handleDownload(doc)}
                    style={{
                      color: "navy",
                      cursor: "pointer",
                      fontSize: isMobile ? "20px" : "24px",
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          );
        })}
      </div>

      {/* Preview Modal */}
      <DocumentModelBox
        open={openModal}
        handleClose={handleCloseModal}
        image_url={previewDoc?.uri}
        type={currentType}
        previewDoc={previewDoc}
      />
    </div>
  );
}

export default DocumentPreview;
